// extracted by css-extract-rspack-plugin
export default {"contentWrapper":"IB3va"};